<template>
  <div class="hello">
    <div class="case">
      <!-- 头部 -->
      <div class="freebirdHeaderCard"></div>
      <div class="top">
        <div class="ti-blck"></div>
        <div class="title">Drone World Congress 2022</div>
        <p class="introduce">
          To register as a speaker, please fill in this form. Thank you for your interest in DWC and we look forward to seeing you in September. Should you have any questions regarding the registration process, please do not hesitate to contact us at
          <a
            href="mailto:int@wuavf.com"
          >int@wuavf.com</a>
        </p>
        <p class="must">*必填</p>
      </div>
      <!-- 尾部 -->
      <el-form
        :model="ruleForm"
        :rules="rules"
        ref="ruleForm"
        label-width="0px"
        class="demo-ruleForm"
      >
        <div class="tail">
          <el-form-item prop="name">
            <label>
              Name
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.name" type="text" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="email">
            <label>
              Email
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.email" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="address">
            <label>
              Address
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.address" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="position">
            <label>
              Position
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.position" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item prop="photo" class="inpdisp">
            <label>
              Photo
              <span class="sign">*</span>
            </label>
            <el-upload
              class="upload-demo"
              action="http://en.droneworldcongress.com/form/index/uploads/index.html"
              :on-change="handleChange"
              :on-success="photo_success"
              accept=".jpg, .jpeg, .png"
              :before-upload="photo_before"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件</div>
            </el-upload>
            <el-input v-model="ruleForm.photo" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item prop="phone_number">
            <label>
              Phone number
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.phone_number" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item>
            <label>
              Website
              <span class="sign"></span>
            </label>
            <el-input v-model="ruleForm.website" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item prop="introduction">
            <label>
              Brief self-introduction (approximately 100 words)
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.introduction" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="tail">
          <el-form-item class="inpdisp">
            <label>
              You may upload a CV here in lieu of your self-introduction
              <span class="sign"></span>
            </label>
            <el-upload
              class="upload-demo"
              action="http://en.droneworldcongress.com/form/index/uploads/index.html"
              :on-change="handleChange"
              :on-success="file_introduction_success"
              accept=".docx, .doc, .pdf, .ppt, .pptx"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传.docx, .doc, .pdf, .ppt, .pptx文件，</div>
            </el-upload>
            <el-input v-model="ruleForm.file_introduction" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="top">
          <div class="ti-blck" style="height:45px">
            <div class="bkcomti">Company information</div>
          </div>
          <p
            class="introduce"
            style="margin-top:40px"
          >Please use the section below to tell us about your company and organisation.</p>
        </div>
        <div class="tail">
          <el-form-item prop="company">
            <label>
              Name of Company or Organisation
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.company" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item prop="c_logo" class="inpdisp">
            <label>
              Logo
              <span class="sign">*</span>
            </label>
            <el-upload
              class="upload-demo"
              action="http://en.droneworldcongress.com/form/index/uploads/index.html"
              :on-change="handleChange"
              :on-success="logo_success"
              accept=".jpg, .jpeg, .png"
              :before-upload="logo_before"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，</div>
            </el-upload>
            <el-input v-model="ruleForm.c_logo" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <div class="top">
          <div class="ti-blck" style="height:45px">
            <div class="bkcomti">Speech Information</div>
          </div>
          <p
            class="introduce"
            style="margin-top:40px"
          >Please use the section below to tell us a bit about the potential topics that you would like to cover.</p>
        </div>

        <div class="tail">
          <el-form-item prop="potential">
            <label>
              Potential topics to talk about
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.potential" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item>
            <label>
              Speech abstracts (approximately 100 words)
              <span class="sign">*</span>
            </label>
            <el-input v-model="ruleForm.speech_abstracts" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>
        <div class="tail">
          <el-form-item class="inpdisp">
            <label>
              You may upload samples of your speaker brief here as your speech abstracts
              <span
                class="sign"
              ></span>
            </label>
            <el-upload
              class="upload-demo"
              action="http://en.droneworldcongress.com/form/index/uploads/index.html"
              :on-change="handleChange"
              :on-success="speech_resume_success"
              accept=".docx, .doc, .pdf, .ppt, .pptx"
            >
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传.docx, .doc, .pdf, .ppt, .pptx文件，</div>
            </el-upload>
            <el-input v-model="ruleForm.speech_resume" placeholder="您的回答"></el-input>
          </el-form-item>
        </div>

        <el-form-item>
          <el-button class="subbin" type="primary" @click="submitForm('ruleForm')">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  data() {
    var checkEmail = (rule, value, callback) => {
      const mailReg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
      if (!value) {
        return callback(new Error("邮箱不能为空"));
      }
      setTimeout(() => {
        if (mailReg.test(value)) {
          callback();
        } else {
          callback(new Error("请输入正确的邮箱格式"));
        }
      }, 100);
    };

    return {
      ruleForm: {
        name: "",
        email: "",
        address: "",
        position: "",
        photo: "",
        phone_number: "",
        website: "",
        introduction: "",
        file_introduction: "",
        company: "",
        c_logo: "",
        potential: "",
        speech_abstracts: "",
        speech_resume: ""
      },
      // fileList: [{
      //     name: 'food.jpeg',
      //     url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
      //   }, {
      //     name: 'food2.jpeg',
      //     url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100'
      //   }],
      // 上传图片

      rules: {
        name: [{ required: true, message: "此项必须填写", trigger: "blur" }],
        email: [
          { required: true, message: "此项必须填写", trigger: "blur" },
          { validator: checkEmail, trigger: "blur" }
        ],
        address: [{ required: true, message: "此项必须填写", trigger: "blur" }],
        position: [
          { required: true, message: "此项必须填写", trigger: "blur" }
        ],
        photo: [{ required: true, message: "此项必须填写", trigger: "blur" }],
        phone_number: [
          { required: true, message: "此项必须填写", trigger: "blur" }
        ],
        introduction: [
          { required: true, message: "此项必须填写", trigger: "blur" }
        ],
        company: [{ required: true, message: "此项必须填写", trigger: "blur" }],
        c_logo: [{ required: true, message: "此项必须填写", trigger: "blur" }],
        potential: [
          { required: true, message: "此项必须填写", trigger: "blur" }
        ]
      }
    };
  },
  beforeCreate() {
    // let button_id = this.$route.query.button_id;
    // let contacts_id = this.$route.query.contacts_id;
    // console.log(button_id);
    // if (localStorage.getItem("button_id") == "") {
    //   localStorage.setItem("button_id", this.$route.query.button_id);
    //   localStorage.setItem("contacts_id", this.$route.query.contacts_id);
    // }

     
  },
  created(){
     this.$axios({
      url:
        "http://en.droneworldcongress.com/form/index/yes_attendee/index.html?button_id=" +
        this.$route.query.button_id +
        "&contacts_id=" +
        this.$route.query.contacts_id,
      method: "get",
      data: { 
      }
    })
  },


  methods: {
    // 上传图片获取参数
    photo_success(res) {
      console.log(res);
      this.ruleForm.photo = res.url;
    },
    photo_before(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过10M!");
      }
    },
    file_introduction_success(res) {
      console.log(res);
      this.ruleForm.file_introduction = res.url;
    },
    logo_success(res) {
      console.log(res);
      this.ruleForm.c_logo = res.url;
    },
    logo_before(file) {
      const isLt2M = file.size / 1024 / 1024 < 10;
      if (!isLt2M) {
        this.$message.error("上传头像图片大小不能超过10M!");
      }
    },
    speech_resume_success(res, file) {
      console.log(res);
      this.ruleForm.speech_resume = res.url;
    },
    handleChange(file, fileList) {
      this.fileList = fileList.slice(-3);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let button_id = this.$route.query.button_id;
          let contacts_id = this.$route.query.contacts_id;
          // alert(this.ruleForm.Nationality);
          let url =
            "http://en.droneworldcongress.com/form/index/yes_attendee/index.html=" +
            button_id +
            "&contacts_id=" +
            contacts_id;
          this.$axios({
            url:
              "http://en.droneworldcongress.com/form/index/yes_attendee/index.html?button_id=" +
              button_id +
              "&contacts_id=" +
              contacts_id,
            method: "post",
            data: {
              name: this.ruleForm.name,
              email: this.ruleForm.email,
              address: this.ruleForm.address,
              position: this.ruleForm.position,
              photo: this.ruleForm.photo,
              phone_number: this.ruleForm.phone_number,
              website: this.ruleForm.website,
              introduction: this.ruleForm.introduction,
              file_introduction: this.ruleForm.file_introduction,
              company: this.ruleForm.company,
              c_logo: this.ruleForm.c_logo,
              potential: this.ruleForm.potential,
              speech_abstracts: this.ruleForm.speech_abstracts,
              speech_resume: this.ruleForm.speech_resume,
              url: url
            }
          })
            .then(res => {
              this.$router.push({ name: "succAttendee" });
            })
            .catch(err => {
              this.$message({
                message: "提交失败",
                type: "warning"
              });
            });
        }
      });
    }
  },
 
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.case {
  margin: auto;
  max-width: 90vw;
  width: 640px;
  padding-top: 12px;
}
.hello {
  width: 100%;
  height: 100%;
  background-color: rgb(226, 238, 224);
  background-size: 100% 100%;
}
.freebirdHeaderCard {
  background-image: url(../../static/tibk.png);
  background-size: cover;
  background-position: center;
  max-height: 22.5vw;
  max-width: 90vw;
  height: 160px;
  width: 640px;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
}
.top {
  /* margin-top: 12px; */
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  padding-top: 22px;
  position: relative;
  text-align: left;
}
.ti-blck {
  background-color: rgb(61, 143, 45);
  color: rgba(255, 255, 255, 1);
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  height: 10px;
  left: -1px;
  position: absolute;
  top: -1px;
  width: calc(100% + 2px);
}
.title {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 32px;
  font-weight: 400;
  line-height: 40px;
  color: #202124;
  line-height: 135%;
  max-width: 100%;
  min-width: 0%;
}
.introduce {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  color: #202124;
  margin-top: 12px;
}
.must {
  font-family: Roboto, Arial, sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.2px;
  line-height: 20px;
  margin-top: 12px;
  color: #d93025;
}

.bkcomti {
  line-height: 45px;
  text-indent: 2em;
}

/* 尾部 */
.tail {
  -webkit-transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  transition: background-color 200ms cubic-bezier(0, 0, 0.2, 1);
  background-color: #fff;
  border: 1px solid #dadce0;
  border-radius: 8px;
  margin-bottom: 12px;
  padding: 24px;
  page-break-inside: avoid;
  word-wrap: break-word;
  text-align: left;
}
.cause {
  font-family: "Google Sans", Roboto, Arial, sans-serif;
  font-size: 16px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 24px;
  color: #202124;
  font-weight: 400;
  width: 100%;
  word-break: break-word;
}
.form-inp {
  margin-left: 0px !important;
}
.sign {
  color: #d93025;
}
/* .elseinp {
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px solid #42b983;
} */
.subbin {
  background-color: rgb(41, 137, 4);
  margin-bottom: 20%;
}
.inpdisp .el-input {
  display: none;
}
h1,
h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/Attendee.vue